import DesignSelect from '../../../../components/select/DesignSelect';
import useOohRoutesDataStore from '../../../../core/hooks/useOohRoutesDataStore';
import { OohRoute } from '../../../../core/graphql/types';
import { ChangeHandler } from '../../types';

export interface OohRouteSelectProps {
  date: string | null;
  agencyId: string | null;
  routeInputValue: string | null;
  routeChangedHandler: ChangeHandler;
}

const OohRouteSelect = ({
  date,
  agencyId,
  routeInputValue,
  routeChangedHandler,
}: OohRouteSelectProps) => {
  const { oohRoutes, areOohRoutesLoading } = useOohRoutesDataStore(
    date,
    agencyId,
  );

  const oohRoutesOptions = oohRoutes?.map((x: OohRoute) => ({
    value: x.id,
    label: x.routeName,
  }));
  return (
    <div className="flex w-full flex-col">
      <label htmlFor="statisticsAgency">Route</label>
      <DesignSelect
        loading={areOohRoutesLoading}
        options={oohRoutesOptions}
        onChange={routeChangedHandler}
        value={oohRoutesOptions?.filter((x) => x.value === routeInputValue)}
      />
    </div>
  );
};

export default OohRouteSelect;
